import Axios from 'axios';
import type { TFunction } from 'i18next';

export const authRequestError = (error: unknown, t: TFunction, fallback = 'error.tryAgain'): string => {
  if (Axios.isAxiosError(error)) {
    if (error.response?.status === 429) {
      const raw = error.response.headers?.['retry-after'] ?? error.response.data?.data?.retry_after;
      const seconds = Number(raw);
      return t('securityAuth.retryAfter', { seconds: Number.isFinite(seconds) && seconds > 0 ? Math.ceil(seconds) : 60 });
    }
    if (error.response?.status === 422 && Array.isArray(error.response.data?.data) && error.response.data.data.includes('Email not unique')) return t('error.emailRegisted');
    if (error.response?.status === 503) return t('securityAuth.temporarilyUnavailable');
  }
  return t(fallback);
};
